import { connect } from 'react-redux';

import { VENUE_SERVICE_TYPES, PERMISSION } from 'constants/logic';
import { ClassesList } from 'components/ClassesList';
import {
  selectActiveVenue,
  selectVenueClasses,
  selectVenueClassesLoaded,
  selectUserHasPermission,
} from 'selectors/general';
import { updateIsServiceEnabled } from './ClassList.saga';
import serviceListMessages from './ClassList.messages';

const mapStateToProps = state => {
  const { venueId, autosyncStatus, serviceTypes } = selectActiveVenue(state);
  const featureIsSupported = autosyncStatus && serviceTypes.includes(VENUE_SERVICE_TYPES.APPOINTMENT);
  const classes = selectVenueClasses(state, venueId);
  const noLinkedClasses = selectVenueClassesLoaded(state, venueId) && classes.length === 0;
  const messages = {
    title: serviceListMessages.title,
    emptyList: serviceListMessages.noServices,
    confirmClassesHeader: serviceListMessages.confirmClassesHeader,
    confirmClassesDescription: serviceListMessages.confirmClassesDescription,
    editClassesHeader: serviceListMessages.editclassesHeader,
  };
  const showEnableClassToggle = selectUserHasPermission(state, PERMISSION.FEATURE_DISABLE_INVENTORY);

  return {
    featureIsSupported,
    classes: selectVenueClasses(state, venueId),
    noLinkedClasses,
    venueId,
    messages,
    showEnableClassToggle,
  };
};

const mapDispatchToProps = {
  updateIsClassEnabled: updateIsServiceEnabled,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassesList);
